module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page__bd bm",
    attrs: {
      "id": "list"
    }
  }, [_c('toobarhead', {
    attrs: {
      "showRefresh": false,
      "showBack": true,
      "showMore": false,
      "titleName": '详情'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-cells weui-cells_form"
  }, [_c('div', {
    staticClass: "weui-cell"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._v(" " + _vm._s(_vm.contract.no) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._v("\n        " + _vm._s(_vm.contract.title) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._v("\n        " + _vm._s(_vm.showProcess) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._v("\n        " + _vm._s(_vm.showAuditState) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._v("\n        " + _vm._s(_vm.contract.owner) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._v("\n        " + _vm._s(_vm.contract.departmentName) + "\n      ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAction),
      expression: "showAction"
    }],
    staticClass: "weui-cell"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._v("\n        " + _vm._s(_vm.contract.actionLabel) + "\n      ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showType),
      expression: "showType"
    }],
    staticClass: "weui-cell"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._v("\n        " + _vm._s(_vm.contract.typeLabel) + "\n      ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAmount),
      expression: "showAmount"
    }],
    staticClass: "weui-cell"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._v("\n        " + _vm._s(_vm.contract.amountLevelLabel) + "\n      ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDirector),
      expression: "showDirector"
    }],
    staticClass: "weui-cell"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._v("\n        " + _vm._s(_vm.contract.director) + "\n      ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPhone),
      expression: "showPhone"
    }],
    staticClass: "weui-cell"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._v("\n        " + _vm._s(_vm.contract.directorTel) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._v("\n        " + _vm._s(_vm.contract.companyName) + "\n      ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.otherCompany),
      expression: "otherCompany"
    }],
    staticClass: "weui-cell"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._v("\n        " + _vm._s(_vm.contract.otherName) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._v("\n        " + _vm._s(_vm.seal) + "\n      ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.contract.type == '4'),
      expression: "this.contract.type=='4'"
    }],
    staticClass: "weui-cell"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._v("\n        " + _vm._s(_vm.showSealType) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._v("\n        " + _vm._s(_vm.showRiskLevel) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._v("\n        " + _vm._s(_vm.showIsNotModify) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._v("\n        " + _vm._s(_vm.createtime) + "\n      ")])]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "weui-cell"
  }, [_c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contract.comment),
      expression: "contract.comment"
    }],
    staticClass: "weui-textarea",
    attrs: {
      "placeholder": "无备注内容",
      "rows": "2",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.contract.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contract, "comment", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cells__title attach"
  }, [_vm._v("合同附件")]), _vm._v(" "), _c('div', {
    staticClass: "weui-cells"
  }, _vm._l((_vm.contract.attachList), function(attach) {
    return _c('a', {
      staticClass: "weui-cell weui-cell_access",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.checkFile(attach)
        }
      }
    }, [_c('div', {
      staticClass: "weui-cell__bd"
    }, [_c('p', [_vm._v(_vm._s(attach.fileName))])]), _vm._v(" "), _c('div', {
      staticClass: "weui-cell__ft"
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "fd"
  }, [_c('div', {
    staticClass: "fd_l fl",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.detail(_vm.contract.id)
      }
    }
  }, [_c('a', {
    staticClass: "btn_batch_repay",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("审批详情")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRevoke),
      expression: "showRevoke"
    }],
    staticClass: "fd_r fr",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.confirmRevoke()
      }
    }
  }, [_c('a', {
    staticClass: "btn_batch_repay",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("审核撤回")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAuditBtn),
      expression: "showAuditBtn"
    }],
    staticClass: "fd_r fr",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.audit(_vm.contract.id)
      }
    }
  }, [_c('a', {
    staticClass: "btn_batch_repay",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("审核")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSealBtn),
      expression: "showSealBtn"
    }],
    staticClass: "fd_r fr",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showSealConfirm()
      }
    }
  }, [_c('a', {
    staticClass: "btn_batch_repay",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("确认盖章")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFileBtn),
      expression: "showFileBtn"
    }],
    staticClass: "fd_r fr",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showFileConfirm()
      }
    }
  }, [_c('a', {
    staticClass: "btn_batch_repay",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("合同归档")])])]), _vm._v(" "), _c('div', {
    staticClass: "weui-popup-container",
    attrs: {
      "id": "contract-full-popupe"
    }
  }, [_c('div', {
    staticClass: "weui-popup-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-popup-modal"
  }, [_vm._m(19), _vm._v(" "), _c('article', {
    staticClass: "weui_article",
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "height": "80%",
      "-webkit-overflow-scrolling": "touch",
      "overflow-y": "scroll"
    }
  }, [_c('iframe', {
    attrs: {
      "src": _vm.path,
      "width": "97%",
      "height": "100%",
      "frameborder": "no",
      "scrolling": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "dialogs"
  }, [_c('div', {
    staticClass: "js_dialog",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "revokeConfirm"
    }
  }, [_c('div', {
    staticClass: "weui-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog"
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._v("确定进行撤回的操作吗")]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancelRevoke.apply(null, arguments)
      }
    }
  }, [_vm._v("放弃")]), _vm._v(" "), _c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.revoke()
      }
    }
  }, [_vm._v("确定")])])])]), _vm._v(" "), _c('div', {
    staticClass: "js_dialog",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "sealConfirm"
    }
  }, [_c('div', {
    staticClass: "weui-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog"
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._v("确定进行盖章的操作吗")]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancelSeal.apply(null, arguments)
      }
    }
  }, [_vm._v("放弃")]), _vm._v(" "), _c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitSeal('seal', '合同盖章')
      }
    }
  }, [_vm._v("确定")])])])]), _vm._v(" "), _c('div', {
    staticClass: "js_dialog",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "fileConfirm"
    }
  }, [_c('div', {
    staticClass: "weui-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog"
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._v("确定进行归档的操作吗")]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancelFile.apply(null, arguments)
      }
    }
  }, [_vm._v("放弃")]), _vm._v(" "), _c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitFile('file', '合同归档')
      }
    }
  }, [_vm._v("确定")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showtip),
      expression: "showtip"
    }],
    staticClass: "js_dialog"
  }, [_c('div', {
    staticClass: "weui-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog"
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._v(_vm._s(_vm.tipContent))]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.goBack.apply(null, arguments)
      }
    }
  }, [_vm._v("知道了")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNoAttachTip),
      expression: "showNoAttachTip"
    }],
    staticClass: "js_dialog showNoAttachTip"
  }, [_c('div', {
    staticClass: "weui-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog"
  }, [_vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._v("当前没有生成可查看附件，请在电脑端登录系统查看")]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.gotit.apply(null, arguments)
      }
    }
  }, [_vm._v("知道了")])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.showOperateSuccessToast) ? _c('div', [_c('div', {
    staticClass: "weui-toast"
  }, [_c('i', {
    staticClass: "weui-icon-success-no-circle weui-icon_toast"
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v("已完成")])])]) : _vm._e()]), _vm._v(" "), (_vm.showProcessToast) ? _c('div', [_c('div', {
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _vm._m(25)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("自动编号  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("文件标题  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("当前流程  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("审批状态  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("申请人  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("所属部门  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("合同类别  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("合同性质  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("标的金额  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("谈判负责人  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("负责人电话  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("我方公司  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("相对方公司  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("所需印章  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("盖章文件类型  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("风险等级  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("不得修改合同  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("创建时间  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell"
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("备注  ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "demos-header"
  }, [_c('p', {
    staticClass: "demos-sub-title"
  }), _c('div', {
    staticClass: "close-popup-btn"
  }, [_c('button', {
    staticClass: "weui-btn weui-btn_plain-default close-popup"
  }, [_vm._v("关闭")])]), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v("确认撤回")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v("确认盖章")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v("确认归档")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v("提示")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v("操作被终止")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-toast"
  }, [_c('i', {
    staticClass: "weui-loading weui-icon_toast"
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v("操作中...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f69071b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contract.vue
// module id = 144
// module chunks = 2